import { linkStats } from './stats.js';

export const loadMore = (target) => {

    const loadTarget = document.querySelector(target);

    if (!loadTarget || !document.querySelector(target)) {
        return;
    }
    let loadTrigger;

    if (loadTarget.nextElementSibling) {
        loadTrigger = loadTarget.nextElementSibling;
    }
    if (!loadTrigger) {
        return;
    }

    const getNext = () => {
        const loadedList = loadTarget.querySelectorAll('.teaser');
        const lastItem = loadedList[loadedList.length - 1];

        const url = lastItem.dataset.next;
        if (!url || url.length < 2) {
            if (loadTrigger) {
                loadTrigger.style.display = 'none';
            }
            return false;
        }
        return url;
    }

    let url = getNext();
    loadTrigger.addEventListener('click', (e) => {
        if (url) {
            fetch(url)
                .then((response) => {
                    if (!response.ok) throw Error(response, url);
                    return response.text();
                })
                .then((html) => {

                    // zapamiętanie ostatniego elementu przed insertem

                    const lastChildBefore = loadTarget.lastElementChild;

                    loadTarget.insertAdjacentHTML("beforeend", html);
                    // teaser

                    // statystyki dla doładowanych zajawek – listenery z main.js
                    // obejmują tylko markup z pierwszego renderu
                    linkStats(loadTarget);


                    setTimeout(() => {

                        let firstNewElement;

                        if (lastChildBefore) {
                            firstNewElement = lastChildBefore.nextElementSibling;
                        } else {
                            // Jeśli loadTarget był pusty, nowy element to pierwszy element w nim
                            firstNewElement = loadTarget.firstElementChild;
                        }

                        if (firstNewElement) {

                            const offset = 50;
                            const scrollH = firstNewElement.getBoundingClientRect().top + window.scrollY - offset;
                            //firstNewElement.scrollIntoView({ behavior: "smooth", block: "start" });
                            window.scrollTo({
                                top: scrollH,
                                behavior: "smooth"
                            });
                        } else {
                            console.warn("Nie znaleziono nowego elementu do przewinięcia.");
                        }

                        // dodanie klasy do nowych zajawek
                        let newElements = [];
                        let current = lastChildBefore ? lastChildBefore.nextElementSibling : loadTarget.firstElementChild;

                        while (current) {
                            newElements.push(current);
                            current = current.nextElementSibling;
                        }
                        newElements.forEach(el => {  
                            if (el.classList.contains("teaser")) {
                                el.classList.add("__jsLoaded");
                            }
                        });

                    }, 50);
                    url = getNext();
                });
        }
    });
};
